import React, {Component} from 'react'
import {base} from '../../base';
import { Redirect } from 'react-router-dom'
import { confirmAlert } from '../../components/utils/react-confirm-alert.js';
import '../../styles/css/react-confirm-alert.css';
import '../../styles/css/ConfirmAlertCustom.css';
import '../../styles/css/Home.css';
import '../../styles/css/main.css';
import '../../styles/css/CreatorAwards.css';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
          redirect: false,
          tenantVariables: {},
          inputedEmail: '',
          userEmail: localStorage.getItem('userEmail') || false,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentWillMount(){
      this.tenantRulesRef = base.bindToState(`tenantRules`, {
        context: this,
        state: 'tenantRules',
      });
    }

    componentDidMount() {
      if(!navigator.cookieEnabled){
        alert("You do not have cookies enabled! Please change the settings of your browser");
        return;
      }
    }

    componentWillUnmount() {
      base.removeBinding(this.tenantRulesRef);
    }

    handleChange(event) {
      this.setState({[event.target.name]: event.target.value});
    }

    handleSubmit(event){
      event.preventDefault();
      if(this.state.inputedEmail.trim() === ""){
        alert("Please Enter An Email!")
        return;
      }
      if(!this.refs.agree_to_rules_regs.checked){
        confirmAlert({
          variables: this.props.variables,
          title: 'Missing Info',
          message: "Please agree to rules and regulations!",
          buttons: [
            {
              label: 'OK',
            }
          ]
        })
        return;
        }
      // Play with ' + this.state.inputedEmail + '?'
      var buttons = [
        {
          label: 'NO',
          onClick: () => {
            console.log("Canceled")
            document.body.classList.remove('react-confirm-alert-body-element')
            const target = document.getElementById('react-confirm-alert')
            target.parentNode.removeChild(target)
            const svg = document.getElementById('react-confirm-alert-firm-svg')
            svg.parentNode.removeChild(svg)
            document.body.children[0].classList.remove('react-confirm-alert-blur')
          }
        },
        {
          label: "YES",
          onClick: () => {
            var base64EncodedEmail = btoa(this.state.inputedEmail);
            var userObject = {};
            userObject['lastSignIn'] = new Date().getTime();
            userObject['email'] = this.state.inputedEmail;
            var vm = this;
            base.post('users/' + base64EncodedEmail, {
              data: userObject,
              context: this,
              then(err){
                if(!err){
                  document.body.classList.remove('react-confirm-alert-body-element')
                  const target = document.getElementById('react-confirm-alert')
                  target.parentNode.removeChild(target)
                  const svg = document.getElementById('react-confirm-alert-firm-svg')
                  svg.parentNode.removeChild(svg)
                  document.body.children[0].classList.remove('react-confirm-alert-blur')
                  try {
                    localStorage.setItem('userEmail', vm.state.inputedEmail);
                    vm.setState({redirect: true})
                  } catch(e){
                    console.log(e)
                    alert("Unable to log you in! Check your settings and try again!")
                  }

                } else {
                  alert("Oh No! There was an error please try again!")
                }
              }
            })
          }
        }
      ]
      var message = "We'll send your prize there if you win and we don't want to send it to the wrong place\n"+ this.state.inputedEmail + "\nIs that correct?"
      confirmAlert({
        title: 'Confirm Email',
        message: message,
        customUI: ({ title, message, onClose }) =>
        <div className='react-confirm-alert-body'>
          {title && <h1 style={{fontWeight:'900'}}>{title}</h1>}
          {/*"We'll send your prize there if you win and we don't want to send it to the wrong place"*/}
          <span className="email-in-popup" style={{fontWeight:'900', color:'black', fontFamily:'Roboto'}}>{this.state.inputedEmail}</span>
          <br/>
          <div className='react-confirm-alert-button-group'>
            {buttons.map((button, i) => (
              <button
                key={i}
                style={{backgroundColor:this.props.variables.primaryColor, color: this.props.variables.secondaryColor}}
                onClick={() => {
                  button.onClick()
                }
                }
              >
                {button.label}
              </button>
            ))}
          </div>
        </div>
      })
    }

    render() {
      const { redirect } = this.state
      var tenantVariables = this.props.variables || {};
      var tenantRules = this.state.tenantRules || {};
      var link = tenantRules.rulesAndRegsLink;
      if (redirect || this.state.userEmail) {
          return (
              <Redirect to="/" />
          )
      }
      return(
          <div className="flex-container-home" style={{backgroundImage: "url(" + tenantVariables.backgroundImage + ")"}}>
            <div className="flex-content-container-home">
              <div className="intro-container-home">
                <div className="hero-text-container">
                  <img src={tenantVariables.frontLogoImage} className="main-hero-image" alt=""/>
                </div>
                <div className="container-out">
                  <div className="question-box question-form" style={{padding:'15px'}}>
                    <h4 style={{fontFamily: "Oswald", fontWeight: 700}}>Enter your email to play</h4>
                    <p className="text-muted" style={{fontFamily: "Roboto"}}>So we know where to send your prize</p>
                    <form onSubmit={this.handleSubmit} id="user-values-form">
                      <div className="input-group">
                        <input id="email" name="inputedEmail" type="email" style={{fontFamily: "Oswald"}} className="form-control" onChange={this.handleChange} placeholder="" />
                      </div>
                      <div className="checkbox" style={{padding:'5px'}}>
                        <label className="agree_to_rules_class"><input type="checkbox" ref="agree_to_rules_regs"/> I have read and agree to the Terms & Conditions</label>
                      </div>
                      <button style={{backgroundColor: tenantVariables.primaryColor, color: tenantVariables.secondaryColor}} className="btn btn-play" id="submitButton"><strong>LETS PLAY!</strong></button>
                    </form>
                    <button className="btn btn-rules" onClick={()=>{window.open(link, '_blank');}}><strong>Rules & Regs</strong></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
      )
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/main_screens/login.js